import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Index from "./pages/Index";
import AtendimentoVip from "./pages/AtendimentoVip";
import EscolaPage from "./pages/Escola";
import DespachantePage from "./pages/Despachante";
import BalnearioCamboriuPage from "./pages/BalnearioCamboriu";
import SaoFranciscoDoSulPage from "./pages/SaoFranciscoDoSul";
import UnidadesPage from "./pages/Unidades";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";

import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import WhatsAppUnitPopup from "./components/WhatsAppUnitPopup";
import { WhatsAppPopupProvider } from "./contexts/WhatsAppPopupContext";
import { useLayoutEffect } from "react";

const queryClient = new QueryClient();

// Componente auxiliar para rolar para o topo ou para a âncora em cada mudança de rota
const ScrollToTop = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    // se a URL tiver uma âncora, rola para o elemento correspondente
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    // caso contrário, rola para o topo da página
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <WhatsAppPopupProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/atendimento-vip" element={<AtendimentoVip />} />
            <Route path="/escola" element={<EscolaPage />} />
            <Route path="/despachante" element={<DespachantePage />} />
            <Route path="/unidades" element={<UnidadesPage />} />
            <Route path="/balneario-camboriu" element={<BalnearioCamboriuPage />} />
            <Route path="/sao-francisco-do-sul" element={<SaoFranciscoDoSulPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <WhatsAppFloatingButton />
          <WhatsAppUnitPopup />
        </BrowserRouter>
      </WhatsAppPopupProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
